import script from "./OGPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./OGPreview.vue?vue&type=script&setup=true&lang=js"

import "./OGPreview.vue?vue&type=style&index=0&id=53c31cdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c31cdd"]])

export default __exports__